import { Component, Self } from '@angular/core';
import { Transition } from '@uirouter/angular';
import { NgOnDestroy } from '@app/shared/services/ng-on-destroy.service';
import { TalentScoutResource } from '@app/shared/modules/resources/talentscout.resource';
import { takeUntil } from 'rxjs/operators';

@Component({
  providers: [NgOnDestroy],
  selector: 'app-referral-decline',
  templateUrl: './referral-decline.component.html',
  standalone: false
})
export class ReferralDeclineComponent {
  token = this.transition.params().token;

  isRemovalDone = false;
  isInProgress = false;

  constructor(
    @Self() private destroy: NgOnDestroy,
    private talentscoutResource: TalentScoutResource,
    private transition: Transition
  ) {}

  decline() {
    if (this.isInProgress) {
      return;
    }

    this.isInProgress = true;

    this.talentscoutResource
      .declineReferral(this.token)
      .pipe(takeUntil(this.destroy))
      .subscribe(
        () => {
          this.isRemovalDone = true;
          this.isInProgress = false;
        },
        () => {
          this.isRemovalDone = true;
          this.isInProgress = false;
        }
      );
  }
}
